/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_143_TitleInputs */

const en_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rainbow Eucalyptus`)
};

const ar_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زهرة قوس قزح`)
};

const de_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenbogen Eukalyptus`)
};

const es_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eucalipto arcoíris`)
};

const fr_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eucalyptus Arc-en-Ciel`)
};

const it_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eucalipto Arcobaleno`)
};

const ja_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レインボーユーカリ`)
};

const ko_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무지개 유칼립투스`)
};

const pt_br_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eucalipto arco-íris`)
};

const ru_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эвкалипт радужный`)
};

const th_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยูคาลิปตัสสีรุ้ง`)
};

const tr_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gökkuşağı Okaliptüsü`)
};

const zh_cn_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`彩虹桉`)
};

const zh_tw_tree_type_143_title = /** @type {(inputs: Tree_Type_143_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`彩虹桉`)
};

/**
* | output |
* | --- |
* | "Rainbow Eucalyptus" |
*
* @param {Tree_Type_143_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_143_title = /** @type {((inputs?: Tree_Type_143_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_143_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_143_title(inputs)
	if (locale === "ar") return ar_tree_type_143_title(inputs)
	if (locale === "de") return de_tree_type_143_title(inputs)
	if (locale === "es") return es_tree_type_143_title(inputs)
	if (locale === "fr") return fr_tree_type_143_title(inputs)
	if (locale === "it") return it_tree_type_143_title(inputs)
	if (locale === "ja") return ja_tree_type_143_title(inputs)
	if (locale === "ko") return ko_tree_type_143_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_143_title(inputs)
	if (locale === "ru") return ru_tree_type_143_title(inputs)
	if (locale === "th") return th_tree_type_143_title(inputs)
	if (locale === "tr") return tr_tree_type_143_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_143_title(inputs)
	return zh_tw_tree_type_143_title(inputs)
});